import moment from 'moment';

export default {
	name: 'ReassignedUserHistoryDialog',

	data() {
		return {
			headerAdditionalUser: [
				{ text: 'Nombre de usuario', sortable: false, value: 'user.fullName' },
				{ text: 'Fecha de reasignación', sortable: false, value: 'created_at' },
				{ text: 'Email', sortable: false, value: 'user.email' },
				{ text: 'Estado', sortable: false, value: 'status' }
			],
		};
	},

	props: {
		value: Boolean,
		item: Object,
	},

	computed: {
		dialog: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},

		formattedReassignments() {
			if (!this.item?.ticket_reassignments_history) return [];

			return this.item.ticket_reassignments_history.map((reassignment, index) => ({
				...reassignment,
				status: index === 0 ? 'Actual' : 'Histórico',
				statusColor: index === 0 ? 'green' : 'grey'
			}));
		},
	},

	methods: {
		close() {
			this.dialog = false;
		},

		formatDate(dateString) {
			if (!dateString) {
				return '-';
			}
			return moment(dateString).format('DD/MM/YYYY HH:mm');
		},
	},
};